module.exports = __webpack_public_path__ + "img/thumbnails-17-breakout-game.1c48d52f.png";